<script setup>
import { computed } from 'vue'
import GenresList from '@components/genre/genres-list'
import extractGenres from '@utils/extract-genres'

const props = defineProps({
    searchResults: {
        type: Object,
        default: () => {},
    },
})

const mixes = computed(() => props.searchResults.Mixes)

const genres = computed(() => mixes.value && extractGenres(mixes.value))
</script>

<template>
    <div>
        <BaseSection
            v-if="genres"
            padded
        >
            <GenresList :genres="genres" />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
